export const COMPANY_EDIT_ROUTE = "/app/companies/$companyId/edit"
